<template>
  <Modal
    :show="show"
    max-width="md"
    :closeable="true"
    @close="$emit('close')"
  >
    <div class="grid w-full">
      <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
        <button
          type="button"
          class="bg-white rounded-md text-font hover:text-font-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          @click="close"
        >
          <span class="sr-only">Close</span>
          <!-- Heroicon name: outline/x -->
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 ml-2 mr-1 mt-3 text-font-light"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
        </svg>
        <h1 class=" mt-3 text-lg font-medium text-font">
          Add new contact
        </h1>
      </div>
      <div class="center m-2">
        <label
          for="name"
          class="sr-only"
        >Name</label>
        <input
          id="name"
          v-model="form.name"
          type="text"
          name="name"
          class=" w-full mt-3 block pr-10 focus:outline-none sm:text-sm rounded-md"
          :class="{'focus:ring-danger focus:border-danger border-danger-light text-danger-dark placeholder-danger-light': form.errors.name, 'focus:ring-primary-light focus:border-primary-light border-gray-300': !form.errors.name}"
          placeholder="Name"
          aria-invalid="true"
          aria-describedby="name-error"
          @change="reset"
        >
        <p
          v-if="form.errors.name"
          id="name-error"
          class="mt-2 text-sm text-red-600"
        >
          {{ form.errors.name }}
        </p>
      </div>
      <div class="flex-1 m-2">
        <label
          for="position"
          class="sr-only"
        >Position</label>
        <input
          id="position"
          v-model="form.position"
          type="text"
          name="position"
          class=" w-full block  pr-10 focus:outline-none sm:text-sm rounded-md"
          :class="{'focus:ring-danger focus:border-danger border-danger-light text-danger-dark placeholder-danger-light': form.errors.position, 'focus:ring-primary-light focus:border-primary-light border-gray-300': !form.errors.position}"
          placeholder="Position"
          aria-invalid="true"
          aria-describedby="position-error"
          @change="reset"
        >
        <p
          v-if="form.errors.position"
          id="position-error"
          class="mt-2 text-sm text-red-600"
        >
          {{ form.errors.position }}
        </p>
      </div>
      <div class="flex-1 m-2">
        <label
          for="email"
          class="sr-only"
        >Email</label>
        <input
          id="email"
          v-model="form.email"
          type="text"
          name="email"
          class="w-full block pr-10 focus:outline-none sm:text-sm rounded-md"
          :class="{'focus:ring-danger focus:border-danger border-danger-light text-danger-dark placeholder-danger-light': form.errors.email, 'focus:ring-primary-light focus:border-primary-light border-gray-300': !form.errors.email}"
          placeholder="Email"
          aria-invalid="true"
          aria-describedby="email-error"
          @change="reset"
        >
        <p
          v-if="form.errors.email"
          id="email-error"
          class="mt-2 text-sm text-red-600"
        >
          {{ form.errors.email }}
        </p>
      </div>
      <div class="flex-1 m-2">
        <label
          for="phone"
          class="sr-only"
        >Phone</label>
        <input
          id="phone"
          v-model="form.phone"
          min="8"
          type="text"
          name="phone"
          class="w-full block  pr-10 focus:outline-none sm:text-sm rounded-md"
          :class="{'focus:ring-danger focus:border-danger border-danger-light text-danger-dark placeholder-danger-light': form.errors.phone, 'focus:ring-primary-light focus:border-primary-light border-gray-300': !form.errors.phone}"
          placeholder="Phone"
          aria-invalid="true"
          aria-describedby="phone-error"
          @change="reset"
        >
        <p
          v-if="form.errors.phone"
          id="phone-error"
          class="mt-2 text-sm text-red-600"
        >
          {{ form.errors.phone }}
        </p>
      </div>
      <div class="flex m-2">
        <button
          type="button"
          class="w-3/4 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-success text-base font-medium text-white hover:bg-success-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success  sm:text-sm"
          @click="save"
        >
          Add
        </button>
        <button
          type="button"
          class="w-1/4 ml-3 inline-flex justify-center rounded-md border border-warning shadow-sm px-4 py-2 bg-warning text-base font-medium text-white hover:bg-warning-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-danger sm:text-sm"
          @click="close"
        >
          Cancel
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>

import Modal from '../../Jetstream/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: [
    'client',
    'show',

  ],
  data() {
    return {
      client_contact: [],
      form: this.$inertia.form({
        name: '',
        position: '',
        email: '',
        phone: '',
        client_id: this.client.id,
      }),
    };
  },
  methods: {
    save() {
      this.form.post(route('contacts.store'), {
        errorBag: 'storeContact',
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.$emit('close');
          this.$emit('newPrimaryContact');
        },
      });
    },
    close() {
      this.$emit('close');
      this.form.reset();
    },

  },
};
</script>
